<template>
  <div class="delivery-note-items-table mt-4 accordion">
    <div v-for="(item, index) in formattedItems" :key="index">
      <div class="p-1" role="tab">
        <b-button block v-b-toggle="`accordion-${note.id}-${index}`" class="text-left">
          {{ item.description }} <small>({{ item.pharmaCode }})</small>
        </b-button>
      </div>
      <b-collapse :id="`accordion-${note.id}-${index}`" :accordion="`accordion-${note.id}`" role="tabpanel">
        <div class="py-1 px-3">
          <div v-for="key in Object.keys(item)" :key="key" class="row py-1">
            <div class="col-6">
              {{ $t(`components.order.deliverynote.deliverynoteitem.${key.toLowerCase()}`) }}
            </div>
            <div class="col-6">
              {{ item[key] }}
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DeliveryNoteItemsTable',
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedItems () {
      return this.note.items.map(item => {
        const formattedItem = { ...item }

        if (formattedItem.expiryDate) {
          formattedItem.expiryDate = this.formatDate(formattedItem.expiryDate)
        }

        // Add CHF to the price fields
        const priceFields = [
          'basePrice',
          'basePriceDiscounted',
          'listPrice',
          'linePriceDiscounted',
          'linePrice'
        ]

        priceFields.forEach(field => {
          if (formattedItem[field] !== undefined) {
            formattedItem[field] = `${formattedItem[field]} CHF`
          }
        })

        // Convert percentage fields (excluding VAT)
        const percentageFields = [
          'discount',
          'serviceCosts'
        ]

        percentageFields.forEach(field => {
          if (formattedItem[field] !== undefined) {
            formattedItem[field] = `${(formattedItem[field] * 100).toFixed(0)}%`
          }
        })

        // Format VAT as percentage
        if (formattedItem.vat !== undefined) {
          formattedItem.vat = `${formattedItem.vat.toFixed(1)}%`
        }

        return formattedItem
      })
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  }
}
</script>
